import { ResponseError } from '../../errors';
import {
  fetchGetNewobjectInfo,
  TGetNewobjectInfoResponse,
} from '../../repositories/monolith-python/v1/get-newobject-info';
import { IApplicationContext } from '../../types/applicationContext';
import { IResidentialComplexInfo } from '../../types/residentialComplexInfo';

interface IFetchResidentialComplexInfoParameters {
  subdomain: string;
  id: number;
}

async function fetchResidentialComplexInfo(
  { httpApi }: IApplicationContext,
  { subdomain, id: newobjectId }: IFetchResidentialComplexInfoParameters,
): Promise<IResidentialComplexInfo | null> {
  const residentialComplexInfoData: TGetNewobjectInfoResponse = await fetchGetNewobjectInfo({
    httpApi,
    parameters: {
      newobjectId,
    },
    config: {
      subdomain,
    },
  });

  if (residentialComplexInfoData.statusCode === 404) {
    return null;
  }

  if (residentialComplexInfoData.statusCode !== 200) {
    throw new ResponseError({
      domain: 'fetchResidentialComplexInfo',
      message: residentialComplexInfoData.response.message,
      details: {
        error: residentialComplexInfoData.response.errors,
      },
    });
  }

  return residentialComplexInfoData.response.data.data;
}

export async function fetchResidentialComplexInfoSafe(
  context: IApplicationContext,
  parameters: IFetchResidentialComplexInfoParameters,
): Promise<IResidentialComplexInfo | null> {
  try {
    return await fetchResidentialComplexInfo(context, parameters);
  } catch (ex) {
    const { logger } = context;

    logger.warning(ex, { degradation: 'Информация о ЖК' });

    return null;
  }
}
